import styleColorThemes from '../content/color-themes'

const TWO_CHARACTER_STATE_NAME = 'TWO_CHARACTER_STATE_NAME'
const FULL_STATE_NAME = 'FULL_STATE_NAME'
const STATE_CODE = 'STATE_CODE'

var THEMES = null

export const TRANSPARENT = "TRANSPARENT"
export const TRANSPARENT_HSLA = "hsla(0,0,100%,0)"
export const OPAQUE_GREY = "hsl(0,0%,87.5%)"
export const OPAQUE_WHITE = "hsl(0,0%,100%)"

const ROYAL_RURAL_RED = 'rgba(205, 148, 127, 0.5)' //"hsl(213.13,66.34%,39.61%)"
const LIGHT_APRICOT = 'rgba(231, 159, 213, 0.5)'

export const FIVE_CHLOROPLETH_COLORS = [
	"hsl(98.49,54.64%,80.98%)",
	"hsl(166.15,43.82%,65.1%)",
	"hsl(186.41,52.61%,51.18%)",
	"hsl(197.3,73.76%,43.33%)",
	"hsl(213.13,66.34%,39.61%)",
]
export const LOWER_VALUE_COLOR = FIVE_CHLOROPLETH_COLORS[1]
export const EQUIVALENT_VALUE_COLOR = '#555'
export const HIGHER_VALUE_COLOR = FIVE_CHLOROPLETH_COLORS[FIVE_CHLOROPLETH_COLORS.length - 1]
export const HIGHLIGHT_UI_COLOR = '#F15C17'

export const SELECTED_COMMUNITY_COLOR = ROYAL_RURAL_RED
export const COMPARISON_COMMUNITY_COLOR = LIGHT_APRICOT
export const FITS_ALL_FILTERS_COLOR = HIGHLIGHT_UI_COLOR

const initThemes = () => {
	THEMES = {}

	styleColorThemes.themes.forEach((theme) => {
		const themeColorsHsl = theme.colors.map((color) => {
			const rgb = color.split(',')
			return rgbToHsl(rgb[0], rgb[1], rgb[2])
		})

		THEMES[theme.id] = themeColorsHsl
	})
}

export const isThemeString = str => {
	return str.includes("theme(")
}

// to read an example:
// getColorsHSLAFromTheme("theme(MULTI_HUE_CYAN_BLUE)", 7, 0.7)
export const getColorsHSLAFromTheme = (str, count=1, alpha=1) => {
	var colors = []
	if (isThemeString(str)) {
		const vals = str.replace("theme(","").replace(")","").replace(/ /g,"").split(",")
		if (vals.length === 1)
			colors = getColorsHSLA(vals[0], count, alpha) // defaults to 1 entry at 100% opacity
		else if (vals.length === 3)
			colors = getColorsHSLA(vals[0], parseInt(vals[1]), parseFloat(vals[2]))
	}
	return colors
}

export const changeAlphaHSL = (hsl, alpha=1) => {
	if (hsl.includes("hsla")) { // already has alpha
		var parts = hsl.split(',')
		parts[3] = alpha + ')'
		return parts.join(',')
	} else {
		return hsl.replace('hsl', 'hsla').replace(')', ',' + alpha + ')')
	}
}

// general color to HSL color (format used throughout the code)
export const convertColorToHSL = (c) => {
	if (c.includes("hsl")) { // already has hsl
		return c
	} else if (c.includes("#")) { // is hex
		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(c)

	    var r = parseInt(result[1], 16)
	    var g = parseInt(result[2], 16)
	    var b = parseInt(result[3], 16)

	    r /= 255
	    g /= 255
	    b /= 255
	    var max = Math.max(r, g, b), min = Math.min(r, g, b)
	    var h, s, l = (max + min) / 2

	    if (max === min){
	        h = s = 0 // achromatic
	    } else {
	        var d = max - min
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break
	            case g: h = (b - r) / d + 2; break
	            case b: h = (r - g) / d + 4; break
							default:
								console.error('Error with color max value', max)
	        }
	        h /= 6
	    }

		s = s * 100
		s = Math.round(s)
		l = l * 100
		l = Math.round(l)
		h = Math.round(360 * h)

		var colorInHSL = 'hsl(' + h + ', ' + s + '%, ' + l + '%)'
		return colorInHSL
	}
}

// get HSLA colors from a theme - assumes count is within the theme's color length
// return as a string if there is only one color
// otherwise return array of hsl/hsla formatted strings
export const getColorsHSLA = (name, count=5, alpha=1) => {
	if (!THEMES) { initThemes() } // lazy load

	// hardcoding in full transparent case
	if (name === TRANSPARENT)
		return TRANSPARENT_HSLA

	var colors = []
	if (name in THEMES) {
		// pull from middle first
		const startIdx = Math.max(0, Math.ceil(THEMES[name].length / 2) - Math.ceil(count/2))
		const endIdx = Math.min(startIdx + count, THEMES[name].length)
		const rgbSub = THEMES[name].slice(startIdx, endIdx)

		colors = rgbSub.map((rgb) => {
			const vals = rgb[0] + "," + rgb[1] + "%," + rgb[2] + "%"
			return alpha === 1 ?
				"hsl(" + vals + ")" :
				"hsla(" + vals + "," + Math.min(1, Math.max(0, alpha)) + ")"
		})

		if (colors.length === 1)
			colors = colors[0] // return as a string
	}

	return colors
}

const roundNumber = (n, digits) => {
	return Math.round(n * Math.pow(10, digits)) / Math.pow(10, digits)
}

const rgbToHsl = (r, g, b) => {
    r /= 255
    g /= 255
    b /= 255
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if(max === min){
        h = s = 0; // achromatic
    } else{
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
					default: break;
        }
        h *= 60;
    }

	s *= 100
	l *= 100
    return [roundNumber(h,2), roundNumber(s,2), roundNumber(l,2)];
}

const STATE_CODE_TO_FULL_NAME = {
	'Alabama': '01',
	'Alaska': '02',
	'Arizona': '03',
	'Arkansas': '04',
	'California': '05',
	'Colorado': '06',
	'Connecticut': '07',
	'Delaware': '08',
	'District of Columbia': '09',
	'Florida': '10',
	'Georgia': '11',
	'Hawaii': '12',
	'Idaho': '13',
	'Illinois': '14',
	'Indiana': '15',
	'Iowa': '16',
	'Kansas': '17',
	'Kentucky': '18',
	'Louisiana': '19',
	'Maine': '20',
	'Maryland': '21',
	'Massachusetts': '22',
	'Michigan': '23',
	'Minnesota': '24',
	'Mississippi': '25',
	'Missouri': '26',
	'Montana': '27',
	'Nebraska': '28',
	'Nevada': '29',
	'New Hampshire': '30',
	'New Jersey': '31',
	'New Mexico': '32',
	'New York': '33',
	'North Carolina': '34',
	'North Dakota': '35',
	'Ohio': '36',
	'Oklahoma': '37',
	'Oregon': '38',
	'Pennsylvania': '39',
	'Rhode Island': '40',
	'South Carolina': '41',
	'South Dakota': '42',
	'Tennessee': '43',
	'Texas': '44',
	'Utah': '45',
	'Vermont': '46',
	'Virginia': '47',
	'Washington': '48',
	'West Virginia': '49',
	'Wisconsin': '50',
	'Wyoming': '51',
}

export const FULL_STATE_NAME_TO_ABBREVIATION = {
	'Alabama': 'AL',
	'Alaska': 'AK',
	'Arizona': 'AZ',
	'Arkansas': 'AR',
	'California': 'CA',
	'Colorado': 'CO',
	'Connecticut': 'CT',
	'Delaware': 'DE',
	'Florida': 'FL',
	'Georgia': 'GA',
	'Hawaii': 'HI',
	'Idaho': 'ID',
	'Illinois': 'IL',
	'Indiana': 'IN',
	'Iowa': 'IA',
	'Kansas': 'KS',
	'Kentucky': 'KY',
	'Louisiana': 'LA',
	'Maine': 'ME',
	'Maryland': 'MD',
	'Massachusetts': 'MA',
	'Michigan': 'MI',
	'Minnesota': 'MN',
	'Mississippi': 'MS',
	'Missouri': 'MO',
	'Montana': 'MT',
	'Nebraska': 'NE',
	'Nevada': 'NV',
	'New Hampshire': 'NH',
	'New Jersey': 'NJ',
	'New Mexico': 'NM',
	'New York': 'NY',
	'North Carolina': 'NC',
	'North Dakota': 'ND',
	'Ohio': 'OH',
	'Oklahoma': 'OK',
	'Oregon': 'OR',
	'Pennsylvania': 'PA',
	'Rhode Island': 'RI',
	'South Carolina': 'SC',
	'South Dakota': 'SD',
	'Tennessee': 'TN',
	'Texas': 'TX',
	'Utah': 'UT',
	'Vermont': 'VT',
	'Virginia': 'VA',
	'Washington': 'WA',
	'West Virginia': 'WV',
	'Wisconsin': 'WI',
	'Wyoming': 'WY',
}

export const LAT_LON_FOR_US_STATES = {
	'Wisconsin': [44.500000, -89.500000],
	'West Virginia': [39.000000, -80.500000],
	'Vermont': [44.000000, -72.699997],
	'Texas': [31.000000, -100.000000],
	'South Dakota': [44.500000, -100.000000],
	'Rhode Island': [41.700001, -71.500000],
	'Oregon': [44.000000, -120.500000],
	'New York': [43.000000, -75.000000],
	'New Hampshire': [44.000000, -71.500000],
	'Nebraska': [41.500000, -100.000000],
	'Kansas': [38.500000, -98.000000],
	'Mississippi': [33.000000, -90.000000],
	'Illinois': [40.000000, -89.000000],
	'Delaware': [39.000000, -75.500000],
	'Connecticut': [41.599998, -72.699997],
	'Arkansas': [34.799999, -92.199997],
	'Indiana': [40.273502, -86.126976],
	'Missouri': [38.573936, -92.603760],
	'Florida': [27.994402, -81.760254],
	'Nevada': [39.876019, -117.224121],
	'Maine': [45.367584, -68.972168],
	'Michigan': [44.182205, -84.506836],
	'Georgia': [33.247875, -83.441162],
	'Hawaii': [20.716179, -158.214676],
	'Alaska': [66.160507, -153.369141],
	'Tennessee': [35.860119, -86.660156],
	'Virginia': [37.926868, -78.024902],
	'New Jersey': [39.833851, -74.871826],
	'Kentucky': [37.839333, -84.270020],
	'North Dakota': [47.650589, -100.437012],
	'Minnesota': [46.392410, -94.636230],
	'Oklahoma': [36.084621, -96.921387],
	'Montana': [46.965260, -109.533691],
	'Washington': [47.751076, -120.740135],
	'Utah': [39.419220, -111.950684],
	'Colorado': [39.113014, -105.358887],
	'Ohio': [40.367474, -82.996216],
	'Alabama': [32.318230, -86.902298],
	'Iowa': [42.032974, -93.581543],
	'New Mexico': [34.307144, -106.018066],
	'South Carolina': [33.836082, -81.163727],
	'Pennsylvania': [41.203323, -77.194527],
	'Arizona': [34.048927, -111.093735],
	'Maryland': [39.045753, -76.641273],
	'Massachusetts': [42.407211, -71.382439],
	'California': [36.778259, -119.417931],
	'Idaho': [44.068203, -114.742043],
	'Wyoming': [43.075970, -107.290283],
	'North Carolina': [35.782169, -80.793457],
	'Louisiana': [30.391830, -92.329102],
}


export const injectCurrentStateNameIfNeeded = (logic, {stateName}) => {
	if (!Array.isArray(logic)) {
		return {
			nullFilterExpression: [],
			formattedExpression: logic,
		}
	}

	let [filter, accessorArray, STATE_NAME_PLACEHOLDER] = logic || []
	if (STATE_NAME_PLACEHOLDER === TWO_CHARACTER_STATE_NAME) {
		STATE_NAME_PLACEHOLDER = FULL_STATE_NAME_TO_ABBREVIATION[stateName]
	} else if (STATE_NAME_PLACEHOLDER === FULL_STATE_NAME) {
		STATE_NAME_PLACEHOLDER = stateName
	} else if (STATE_NAME_PLACEHOLDER === STATE_CODE) {
		STATE_NAME_PLACEHOLDER = STATE_CODE_TO_FULL_NAME[stateName]
	}

	const field = accessorArray[0] === "get" ? accessorArray[1] : accessorArray[1][1]
	return {
		nullFilterExpression: [
			["==", ["get", field], null],
			getColorsHSLAFromTheme('theme(TRANSPARENT)'),
		],
		formattedExpression: [filter, accessorArray, STATE_NAME_PLACEHOLDER],
	}
}
